import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const onboardingRoutes = {
  name: 'onboarding-store',
  path: 'onboarding',
  component: () => import('./Onboarding.vue'),
  meta: { requireAuth: true, i18n },
} satisfies RouteRecordRaw;
